import {
  compact,
  flow,
  isEmpty,
  values,
  isObject,
  every,
  isString,
  map,
} from "lodash";

export const isEmptyObject = flow(values, compact, isEmpty);

/**
 * The purpose of this function is to take any type of variable and determine if it's "empty"
 * The definition of empty varies depending on what data type we're dealing with. This function abstracts that from us.
 * https://stackoverflow.com/a/43233163
 */
export function isEmptyValues(value: string | object | [] | number) {
  return (
    value === undefined ||
    value === null ||
    (typeof value === "object" && Object.keys(value).length === 0) ||
    (typeof value === "string" && value.trim().length === 0)
  );
}

/**
 * This is a helper function that, given an object, it will do recursive "deep" search to assert if every
 * key/value pair in the object is "empty" or not. In particular, it will assert if child objects are empty.
 *
 * This function is similar to isEmptyValues. The main difference is this function traverses through the object,
 * where isEmptyValues is meant to be called with an iterator.
 *
 * https://stackoverflow.com/a/54678430
 */
export function isEmptyDeep(obj: object | [] | string): boolean {
  if (isObject(obj)) {
    if (Object.keys(obj).length === 0) return true;
    return every(map(obj, (v) => isEmptyDeep(v)));
  } else if (isString(obj)) {
    return !obj.length;
  }
  return false;
}
